import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { Component } from "react";
import locales from "../../../_constants/locales";
import StyledButton from "../../../components/StyledButton.jsx";
import Item from "../containers/Item";
import "../styles/Request.css";
import "../styles/RequestDetails.css";

class Request extends Component {
    constructor(props) {
        super(props);
        this.state = {
            blockedTrackingUrl: null
        };
    }

    getTrackingUrl(fulfillment) {
        const rawTrackingUrl = (fulfillment && fulfillment.trackingUrl) || null;

        if (!rawTrackingUrl || typeof rawTrackingUrl !== "string") {
            return null;
        }

        const trimmedTrackingUrl = rawTrackingUrl.trim();

        if (!trimmedTrackingUrl) {
            return null;
        }

        if (/^https?:\/\//i.test(trimmedTrackingUrl)) {
            return trimmedTrackingUrl;
        }

        if (/^\/\//.test(trimmedTrackingUrl)) {
            return `https:${trimmedTrackingUrl}`;
        }

        return `https://${trimmedTrackingUrl}`;
    }

    handleTrackingClick(fulfillment) {
        const trackingUrl = this.getTrackingUrl(fulfillment);

        if (!trackingUrl) {
            return;
        }

        // Open target URL directly to avoid extensions allowing popup creation
        // but blocking script-driven location changes in a blank popup.
        const trackingWindow = window.open(trackingUrl, "_blank");

        if (trackingWindow) {
            trackingWindow.opener = null;
            this.setState({ blockedTrackingUrl: null });
            return;
        }

        this.setState({ blockedTrackingUrl: trackingUrl });
    }

    handleSameTabTrackingOpen(e) {
        if (e) {
            e.preventDefault();
        }

        if (!this.state.blockedTrackingUrl) {
            return;
        }

        window.location.assign(this.state.blockedTrackingUrl);
    }

    render() {
        const trackingInformation = locales[this.props.language.code].TICKET.REQUEST_DETAILS.TRACKING_INFORMATION;
        const popupBlockedPrefix = trackingInformation.POPUP_BLOCKED_PREFIX || "Pop-up blocked. Allow pop-ups for this site, or open tracking ";
        const popupBlockedLinkLabel = trackingInformation.POPUP_BLOCKED_LINK_LABEL || "here";
        const requestFulfillments = this.props.request.requestFulfillments || [];
        const inboundFulfillment = requestFulfillments.find(rf => rf && rf.type && rf.type.toUpperCase() === "INBOUND");
        const outboundFulfillment = requestFulfillments.find(rf => rf && rf.type && rf.type.toUpperCase() === "OUTBOUND");
        const inboundTrackingUrl = this.getTrackingUrl(inboundFulfillment);
        const outboundTrackingUrl = this.getTrackingUrl(outboundFulfillment);

        return (
            <section className="flex layout center">
                <div className="flex layout vertical">
                    <div>
                        <div className="flex layout vertical">
                            <div className="flex layout request-details-boxes">
                                {this.props.request.returnItems && this.props.request.returnItems.length > 0 && (
                                    <div className="flex layout vertical request-details-box">
                                        <h3 className="item-list-title">{locales[this.props.language.code].TICKET.REQUEST_DETAILS.RETURN_ITEMS.TITLE}</h3>
                                        {this.props.request.returnItems.map((returnItem, i) => (
                                            <Item
                                                key={i}
                                                item={returnItem}
                                                type={"return"}
                                                handleChange={this.props.handleChange ? this.props.handleChange.bind(this) : null}
                                                showDetails={this.props.view === "TICKET_CONFIRMATION_PAGE"}
                                                disabled={this.props.view === "TICKET_PAGE"}
                                                // clickable={this.props.view === "TICKET_PAGE"}
                                                language={this.props.language}
                                            />
                                        ))}
                                        {this.props.view === "TICKET_PAGE" &&
                                            this.props.request.inboundTrackingAvailable &&
                                            this.props.request.inboundTrackingAvailable === true &&
                                            inboundTrackingUrl &&
                                            !this.props.requestIsCancelled && (
                                                <StyledButton
                                                    id="submit-button-id"
                                                    onClick={this.handleTrackingClick.bind(this, inboundFulfillment)}
                                                    variant="contained"
                                                    className="styled-button"
                                                >
                                                    <span className="tracking-button-content">
                                                        <span>
                                                            {locales[this.props.language.code].TICKET.REQUEST_DETAILS.TRACKING_INFORMATION.INBOUND.LABEL}
                                                        </span>
                                                        <OpenInNewIcon className="tracking-button-icon" aria-hidden="true" />
                                                    </span>
                                                </StyledButton>
                                            )}
                                    </div>
                                )}
                                {this.props.request.replacementItems &&
                                    this.props.request.replacementItems.length > 0 &&
                                    this.props.request.returnItems &&
                                    this.props.request.returnItems.length > 0 && (
                                        <div className="vertical-separator-inner-fade" style={{ margin: "0px 10px" }} />
                                    )}
                                {this.props.request.replacementItems && this.props.request.replacementItems.length > 0 && (
                                    <div className="horizontal-separator-inner dynamic" />
                                )}
                                {this.props.request.replacementItems && this.props.request.replacementItems.length > 0 && (
                                    <div className="flex layout vertical request-details-box">
                                        <h3 className="item-list-title">{locales[this.props.language.code].TICKET.REQUEST_DETAILS.REPLACEMENT_ITEMS.TITLE}</h3>
                                        {this.props.request.replacementItems.map((replacementItem, i) => (
                                            <Item
                                                key={i}
                                                item={replacementItem}
                                                type={"replacement"}
                                                handleChange={this.props.handleChange ? this.props.handleChange.bind(this) : null}
                                                showDetails={this.props.view === "TICKET_CONFIRMATION_PAGE"}
                                                disabled={this.props.view === "TICKET_PAGE"}
                                                // clickable={this.props.view === "TICKET_PAGE"}
                                                language={this.props.language}
                                            />
                                        ))}
                                        {this.props.view === "TICKET_PAGE" &&
                                            this.props.request.outboundTrackingAvailable &&
                                            this.props.request.outboundTrackingAvailable === true &&
                                            outboundTrackingUrl &&
                                            !this.props.requestIsCancelled && (
                                                <StyledButton
                                                    id="submit-button-id"
                                                    onClick={this.handleTrackingClick.bind(this, outboundFulfillment)}
                                                    variant="contained"
                                                    className="styled-button"
                                                >
                                                    <span className="tracking-button-content">
                                                        <span>
                                                            {locales[this.props.language.code].TICKET.REQUEST_DETAILS.TRACKING_INFORMATION.OUTBOUND.LABEL}
                                                        </span>
                                                        <OpenInNewIcon className="tracking-button-icon" aria-hidden="true" />
                                                    </span>
                                                </StyledButton>
                                            )}
                                    </div>
                                )}
                            </div>
                            {this.state.blockedTrackingUrl && (
                                <div className="tracking-fallback-note" role="status" aria-live="polite">
                                    <p>
                                        {popupBlockedPrefix}
                                        <a
                                            href={this.state.blockedTrackingUrl}
                                            className="tracking-fallback-link"
                                            onClick={this.handleSameTabTrackingOpen.bind(this)}
                                        >
                                            {popupBlockedLinkLabel}
                                        </a>
                                        .
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Request;
